<template>
  <span>
    <ACLAvatar
      v-for="accessor in listToShow"
      :key="accessor.entityId"
      :accessor="accessor"
      :avatar-props="avatarProps"
      class="ml-1"
    />
    <AvatarComponent
      v-if="ellipsisNumber > 0"
      :size="avatarProps.size"
      color="primary"
      text-color="white"
      :text="`+${ellipsisNumber}`"
    />
  </span>
</template>
<script>
import AvatarComponent from './AvatarComponent';
import ACLAvatar from './ACLAvatar';
import { ACL_TYPE_GROUP } from '../../constants/backendConstants';

export default {
  components: { ACLAvatar, AvatarComponent },
  name: 'ACLAvatarList',
  props: {
    acl: {
      type: Array,
      required: true,
      default: () => [],
    },
    justify: {
      type: String,
      default: 'end',
    },
    ellipsis: {
      type: Boolean,
      default: true,
    },
    beforeEllipsis: {
      type: Number,
      default: 2,
    },
    avatarProps: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    listToShow() {
      if (this.showEllipsis) {
        return this.sortedAcl.slice(0, this.beforeEllipsis);
      }

      return this.sortedAcl;
    },
    showEllipsis() {
      return this.ellipsis && this.acl.length > this.beforeEllipsis;
    },
    ellipsisNumber() {
      if (this.acl.length <= this.beforeEllipsis) return 0;

      return this.acl.length - this.beforeEllipsis;
    },
    sortedAcl() {
      const groupAcl = [];
      const userAcl = [];

      this.acl.forEach(acl => {
        if (!acl.displayName) return;
        if (acl.entityType === ACL_TYPE_GROUP) {
          groupAcl.push(acl);
        } else {
          userAcl.push(acl);
        }
      });

      // Show group acl before user acl
      return groupAcl.concat(userAcl);
    },
  },
};
</script>
